import React from 'react';

import Breadcumb from './Breadcumb';
import Benefits from './Benefits';
import TicketPartners from './TicketPartners';
import CallToAction from './CallToaction';

function Main() {
  return (
    <>
      <Breadcumb />
      <Benefits />
      <TicketPartners />
      <CallToAction />
    </>
  );
}

export default Main;
